// Fachada do domínio Notifications — métodos da instância (ver core.ts).
import { notificationsService } from './core';

// ─── Operações com dados (via adapter) ──────────────────────────
export const listNotifications         = notificationsService.listNotifications;
export const countUnreadNotifications  = notificationsService.countUnreadNotifications;
export const markNotificationsRead     = notificationsService.markNotificationsRead;
export const markAllNotificationsRead  = notificationsService.markAllNotificationsRead;
export const dismissNotification       = notificationsService.dismissNotification;
export const getNotificationPrefs      = notificationsService.getNotificationPrefs;
export const saveNotificationPrefs     = notificationsService.saveNotificationPrefs;

// ─── Funções puras (reexportadas do módulo) ─────────────────────
export {
  NOTIFICATION_KIND_META,
  getNotificationKindMeta,
  DEFAULT_NOTIFICATION_PREFS,
  leadTimeLabel,
  splitByRead,
} from '@modules/notifications';

// ─── Tipos ──────────────────────────────────────────────────────
export type {
  ListNotificationsQuery,
  SavePrefsData,
} from '@modules/notifications';
